/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "Device": {
                        "fields": {
                          "humanReadableName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "uniqueDeviceId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "deviceCodeId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "deviceUdid": {
                            "type": "string",
                            "id": 1
                          },
                          "deviceCodeToken": {
                            "type": "string",
                            "id": 2
                          }
                        },
                        "nested": {
                          "id": {
                            "oneof": ["deviceUdid", "deviceCodeToken"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.Device) {
  $root.addJSON(jsonData);
}

/**
 * DEPRECATED! DO NOT USE! Use /shared/device.proto instead.
 *
 * SOURCE Device @ squareup/devicesettings/profiles/v2/model/device.proto at 11:1
 */
export const Device = $root.lookupType('squareup.devicesettings.profiles.v2.model.Device');
fixType(Device);
Builder.createAndAttachToType(Device);